document.addEventListener('DOMContentLoaded', function() {
    const pageLoadingType = performance.getEntriesByType("navigation")[0].type
    const currentUrl = window.location.href;
    const url = new URL(currentUrl);
    const scrollStorageIndexName = `${window.location.pathname}-scroll`
    if (pageLoadingType !== 'back_forward' && url.searchParams.get('page')) {
        localStorage.removeItem(scrollStorageIndexName)
        url.searchParams.delete('page');
        window.location.href = url.toString();
    }
    let productGrid = document.querySelector('.collection__products .product-grid');
    const paginatePerPage = parseInt(productGrid.dataset.perPage);
    const canShowMore = productGrid.dataset.canShowMore === 'true';

    let loading = false;
    let canLoadMore = true;
    let currentPage = parseInt(new URLSearchParams(new URL(currentUrl).search).get('page')) || 1;
    let earliestPage = currentPage;
    let latestPage = currentPage;
    let currentScrolledPage = currentPage;
    const loadedPages = [currentPage];
    let prevScrollPos = window.scrollY;

    window.addEventListener('beforeunload', function() {
        if (new URL(window.location.href).searchParams.get('page') > 1) {
            localStorage.removeItem(scrollStorageIndexName)
            const nodeList = document.querySelectorAll('.product-grid > .product-item');
            const elementToFind = getFirstVisibleElement('product-item');
            const index = Array.from(nodeList).indexOf(elementToFind);

            if (index > -1) {
                localStorage.setItem(scrollStorageIndexName, JSON.stringify({
                    index: index - (loadedPages.length - 1) * paginatePerPage,
                    offsetTop: elementToFind.getBoundingClientRect().top
                }));
            }
        }
    })

    if (currentPage > 1 && localStorage.getItem(scrollStorageIndexName)) {
        scrollToElementByIndex(JSON.parse(localStorage.getItem(scrollStorageIndexName)))
    } else if (canShowMore) {
        hideIncompleteRow();
    }

    function scrollToElementByIndex({ index, offsetTop }) {
        const elements = document.querySelectorAll('.product-item'); // Replace with your selector

        if (index >= 0 && index < elements.length) {
            setTimeout(function () {
                window.scrollTo({
                    top: elements[index].getBoundingClientRect().top + window.scrollY + offsetTop,
                    behavior: 'smooth'}
                );
            }, 1000)
        }
    }

    function revealHiddenItems () {
        document.querySelectorAll('.collection__products .product-item').forEach(el => {
            el.classList.remove('hide', 'medium-up--hide')
        })
    }

    function hideIncompleteRow () {
        const items = document.querySelectorAll('.collection__products .product-item') || [];
        const productItems = document.querySelectorAll('.collection__products .product-item:not(.product-item--featured-image)') || [];
        const bannersOneCol = document.querySelectorAll('.product-item--featured-image.large-up--one-quarter') || [];
        const bannersTwoCol = document.querySelectorAll('.product-item--featured-image.large-up--one-half') || [];
        const itemsLength = productItems.length + bannersOneCol.length + bannersTwoCol.length * 2;
        const modulo = itemsLength % 4;

        if (modulo === 1) {
            items[items.length - 1].classList.add('medium-up--hide')
        } else if (modulo === 2) {
            items[items.length - 1].classList.add('medium-up--hide')
            items[items.length - 2].classList.add('medium-up--hide')
        } else if (modulo === 3) {
            items[items.length - 1].classList.add('medium-up--hide')
            items[items.length - 2].classList.add('medium-up--hide')
            items[items.length - 3].classList.add('medium-up--hide')
        }
    }

    async function fetchProducts (params, isScrollDirectionDown, page, loadingButton, loadMore) {
        loading = true;
        loadingButton.style.display = 'block';
        if (loadMore) {
            document.getElementById('loadMore').style.display = 'none';
        }
        const fetchUrl = `${window.location.pathname}?${params.toString()}`;

        const xhr = new XMLHttpRequest();
        await xhr.open('GET', fetchUrl, true);
        xhr.onreadystatechange = function() {
            if (xhr.readyState === 4 && xhr.status === 200) {
                const data = xhr.responseText;
                const parser = new DOMParser();
                const doc = parser.parseFromString(data, 'text/html');
                const products = doc.querySelectorAll('.collection__products .product-grid > *:not(.no-results):not(.product-item--featured-image)');
                productGrid = document.querySelector('.collection__products .product-grid');
                if (products.length > 0) {
                    revealHiddenItems();
                    if (loadMore || isScrollDirectionDown) {
                        products.forEach((product) => {
                            document.dispatchEvent(new CustomEvent('theme:scroll:load-products', {bubbles: true, detail: product}))
                            productGrid.appendChild(product)
                            const deferredMedia = product.querySelector('deferred-media');
                            if (deferredMedia && deferredMedia.querySelector('video')) {
                                deferredMedia.querySelector('video').play();
                            }
                        });
                        latestPage = page;
                    } else {
                        earliestPage = page;
                        for (let i = products.length - 1; i >= 0; i--) {
                            productGrid.insertBefore(products[i], productGrid.firstChild);
                        }
                    }
                    loadedPages.push(page);
                    if (loadMore && products.length < paginatePerPage) {
                        document.getElementById('loadMore').style.display = 'none';
                        canLoadMore = false;
                    }
                } else {
                    canLoadMore = false;
                }
                loading = false;
                loadingButton.style.display = 'none';
                document.querySelector('.loaded').textContent = document.querySelectorAll('.collection__products .product-item:not(.product-item--featured-image)').length;
                document.querySelector('.current-progress').style.width = `${parseInt(document.querySelector('.loaded').textContent) * 100 / parseInt(document.querySelector('.total').textContent)}%`;

                if (canLoadMore) {
                    hideIncompleteRow();
                } else {
                    revealHiddenItems();
                }

                if (loadMore && products.length > 0 && canLoadMore) {
                    document.getElementById('loadMore').style.display = 'block';
                }
                initSwatches();
            }
        };
        xhr.send();
    }

    async function loadMoreProducts(page, isScrollDirectionDown, loadMore) {
        let loadMoreButtonBottom = document.querySelector('.load-more--bottom');
        let loadMoreButtonTop = document.querySelector('.load-more--top');
        const loadingButton = isScrollDirectionDown ? loadMoreButtonBottom : loadMoreButtonTop;

        const params = new URLSearchParams(new URL(window.location.href).search);
        params.set('page', page);

        await fetchProducts(params, isScrollDirectionDown, page, loadingButton, loadMore);
    }

    const throttledScroll = throttle(handleScroll, 250);

    function handleScroll() {
        const currentScrollPos = window.scrollY;
        const isScrollDirectionDown = currentScrollPos > prevScrollPos;
        prevScrollPos = currentScrollPos;

        const distanceToBottom = document.documentElement.offsetHeight - (window.innerHeight + currentScrollPos);
        const distanceToTop = currentScrollPos;
        const pagesThreshold = currentScrolledPage + 1 - earliestPage;

        if (pagesThreshold > 0) {
            const nextPageElIndex = pagesThreshold * paginatePerPage + 4;
            const prevPageElIndex = pagesThreshold > 1 ? (pagesThreshold - 1) * paginatePerPage + 4 : -1;
            const nextPageEl = document.querySelector(`.product-grid > *:nth-child(${nextPageElIndex})`);
            const prevPageEl = document.querySelector(`.product-grid > *:nth-child(${prevPageElIndex})`);
            if ((isScrollDirectionDown && isElementVisible(nextPageEl, true)) || (!isScrollDirectionDown && isElementVisible(prevPageEl, false))) {
                currentScrolledPage = currentScrolledPage + (isScrollDirectionDown ? 1 : -1)
                updateUrl(currentScrolledPage);
            }
        }

        const recentlyViewedHeight = document.querySelector('.recent__container')?.offsetHeight || 0

        if ((isScrollDirectionDown && distanceToBottom < document.getElementById('shopify-section-footer').offsetHeight + recentlyViewedHeight - 100 && !loading && canLoadMore) ||
            (!isScrollDirectionDown && currentPage > 1 && distanceToTop < productGrid.getBoundingClientRect().top - 100 && !loading)) {
            currentPage += isScrollDirectionDown ? 1 : -1;
            if (!loadedPages.includes(currentPage)) {
                loadMoreProducts(currentPage, isScrollDirectionDown);
            }
        }
    }

    if (document.querySelector('.collection-products').dataset.navigationType === 'infinite-scroll') {
        window.addEventListener('scroll', throttledScroll);
    } else {
        document.getElementById('loadMore').addEventListener('click', function() {
            currentPage++;
            loadMoreProducts(currentPage, true, true)
        });
    }

    function throttle(func, limit) {
        let inThrottle;
        return function() {
            const context = this;
            const args = arguments;
            if (!inThrottle) {
                func.apply(context, args);
                inThrottle = true;
                setTimeout(() => {
                    inThrottle = false;
                }, limit);
            }
        };
    }

    function updateUrl(page) {
        const url = new URL(window.location.href);
        const urlParams = new URLSearchParams(url.search);
        page > 1 ? urlParams.set('page', page) : urlParams.delete('page')
        history.pushState(null, null, `${url.pathname}?${urlParams.toString()}`);
    }

    function isElementVisible(element, isScrollDirectionDown) {
        if (!element) {
            return false;
        }
        const rect = element.getBoundingClientRect();
        const windowHeight = window.innerHeight || document.documentElement.clientHeight;
        return isScrollDirectionDown ? rect.top <= windowHeight : rect.bottom >= windowHeight;
    }

    function initSwatches () {
        const swatchElements = productGrid.querySelectorAll('.product-item .product-colors [data-swatch]:not([style])');
        swatchElements.forEach((el) => {
            new window.theme.Swatch(el);
            el.addEventListener('click', () => {
                const product = el.closest('.product-item');
                product.querySelector('.swatch__button.active')?.classList.remove('active');
                const button = el.closest('.swatch__button');
                const swatchIndex = parseInt(button.dataset.index);
                button.classList.add('active');
                product.querySelector('.product-link').setAttribute('href', button.dataset.productUrl)
                product.querySelector('.slideup [data-quick-add-label]').setAttribute('data-quick-add-label', button.dataset.quickAddLabel)
                product.querySelector('[data-quick-add-form-holder]').innerHTML = '&nbsp;';
                document.dispatchEvent(new CustomEvent('theme:grid-item:swatch-change', {bubbles: true, detail: product}));
                product.dispatchEvent(new Event('mouseenter'));
                product.querySelector('[data-grid-item-slider].current')?.classList.remove('current');
                product.querySelector(`[data-grid-item-slider][data-color="${el.dataset.swatch}"]`).classList.add('current');
                product.querySelector(`.product-discount.active`)?.classList.remove('active');
                product.querySelector(`.product-discount[data-index="${swatchIndex}"]`)?.classList.add('active');
                product.querySelector(`.price.active`)?.classList.remove('active');
                product.querySelector(`.price[data-index="${swatchIndex}"]`)?.classList.add('active');
            })
        });
    }

    initSwatches();

    function getFirstVisibleElement(className) {
        const elements = document.querySelectorAll(className);

        for (const element of elements) {
            const rect = element.getBoundingClientRect();
            const isVisible = rect.top < window.innerHeight && rect.bottom - 90 > 0;

            if (isVisible) {
                return element;
            }
        }

        return null;
    }
});
